import store from '@/data/store'
// 全局权限判断
export const filterPermission = {
  inserted: function (el, data) {
    let _allKeys = store.getters.permission.rolePermission.checkedKeys.concat(store.getters.permission.rolePermission.halfCheckedKeys)
    if (_allKeys.indexOf(data.value) < 0) {
      el.remove()
    }
  }
}

export const loading = {
  inserted: function (el, data) {
  },
  update: function (el, data) {
    let _dom = document.createElement('div')
    _dom.className = 'mint-spinner-snake'
    _dom.style = 'border-top-color: rgb(38, 162, 255);margin:0 auto; border-left-color: rgb(38, 162, 255); border-bottom-color: rgb(38, 162, 255); height: 28px; width: 28px;'
    if (data.value) {
      el.children[0].style.display = 'none'
      el.appendChild(_dom)
    } else {
      el.children[0].style.display = 'block'
      el.removeChild(el.lastChild)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/directives/index.js